import axios from "axios"

export const getHubspotForms = async (accountId) => {
	return (await axios.get(`${process.env.REACT_APP_HUBSPOT_ENDPOINT}/get-forms/${accountId}`)).data
}